import Swiper from 'swiper/dist/js/swiper.min';
import PopupFullscreen from '../popup/fullscreen/popup-fullscreen';
import AnimationFade from '../../core/animation/fade/animation-fade';
import baseSlider from './baseSlider.pug';
import ListMap from '../map/list/list-map';
import Select from '../../core/select/select';

export default {
  template: baseSlider(),
  delimiters: ['${', '}}'],
  components: {
    AnimationFade,
    PopupFullscreen,
    ListMap,
  },
  props: {
    slider: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      mainSlider: null,
      thumbsSlider: null,
      popupFullOpen: false,
      fullscreenActive: 0,
      mediaArray: [],
      btnPopupFull: true,
      isMobile: false,
    };
  },
  mounted() {
    this.activeTabs = this.$el.querySelectorAll('.baseSlider__tab--active');
    Array.from(this.activeTabs).forEach((tab) => {
      if (tab.dataset.type === 'slider') {
        this.sliderInit(tab);
      } else {
        this.btnPopupFull = false;
      }
      if (tab.dataset.type === 'video') {
        this.btnPopupFull = true;
      }
    });

    if (this.slider.noBtnPopupFull) {
      this.btnPopupFull = false;
    }

    if (window.innerWidth <= 767) {
      this.isMobile = true;
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth <= 767) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    });
    this.initSelects();
  },
  methods: {
    sliderInit(tab) {
      this.thumbsSlider = new Swiper(tab.querySelector('.baseSlider__thumb-slider'), {
        slideToClickedSlide: true,
        slidesPerView: 'auto',
        spaceBetween: 10,
      });

      const thumbs = this.thumbsSlider;

      this.mainSlider = new Swiper(tab.querySelector('.baseSlider__main-slider'), {
        slidesPerView: 1,
        navigation: {
          nextEl: '.sliderButtons__btn--next',
          prevEl: '.sliderButtons__btn--prev',
        },
        thumbs: {
          swiper: thumbs,
        },
        on: {
          init() {
            if (this.slides.length <= 1) {
              if (tab.querySelector('.baseSlider__slider-btns')) {
                tab.querySelector('.baseSlider__slider-btns').style.display = 'none';
              }
            }
            if (thumbs !== undefined) {
              const slides = [].slice.call(thumbs.slides);
              if (slides) {
                slides.forEach(tmp => tmp.classList.remove('baseSlider__thumb-slide--active'));
                slides[this.realIndex].classList.add('baseSlider__thumb-slide--active');
                if (thumbs.slides.length === 1) {
                  tab.querySelector('.baseSlider__thumb-slider').style.display = 'none';
                }
              }
              thumbs.slideTo(this.realIndex);
            }
          },
          slideChange() {
            if (thumbs !== undefined) {
              const slides = [].slice.call(thumbs.slides);
              slides.forEach(tmp => tmp.classList.remove('baseSlider__thumb-slide--active'));
              slides[this.realIndex].classList.add('baseSlider__thumb-slide--active');
              thumbs.slideTo(this.realIndex);
              thumbs.activeIndex = this.realIndex;
              thumbs.clickedIndex = this.realIndex;
            }
          },
        },
      });

      this.mainSlider.params.controller.control = this.thumbsSlider;
      this.thumbsSlider.params.controller.control = this.mainSlider;

      if (this.slider.noBtnPopupFull) {
        this.btnPopupFull = false;
      } else {
        this.btnPopupFull = true;
      }
    },

    initSelects(clear = false) {
      this.$nextTick(() => {
        const selectsElems = [].slice.call(this.$el.querySelectorAll('.select'));
        if (selectsElems.length !== 0) {
          selectsElems.forEach((el) => {
            if (clear) {
              const selects = [].slice.call(el.querySelectorAll('select'));
              selects.forEach((select, index) => {
                if (!select.multiple) {
                  const options = [].slice.call(select.options);
                  if (index > 0) {
                    select.value = options[options.length - 1].value;
                  } else {
                    select.value = options[0].value;
                  }
                }
              });
            }
            if (!el.classList.contains('cselect--inited')) {
              el.select = new Select(el);
            } else {
              const cselect = el.querySelector('.cselect');
              if (cselect) {
                el.select = el.removeChild(cselect);
                el.select = null;
              }
              el.select = new Select(el);
            }
          });
        }
      });
    },

    checkValue(e) {
      const galleryTabs = [].slice.call(this.$el.querySelectorAll('.baseSlider__tab'));
      galleryTabs.forEach((elem) => {
        if (elem.dataset.name === e.target.value) {
          elem.classList.add('baseSlider__tab--active');
          if (elem.dataset.type === 'slider') {
            if (this.mainSlider && this.thumbsSlider) {
              this.mainSlider.destroy();
              this.thumbsSlider.destroy();
            }
            this.sliderInit(elem);
          } else if (elem.dataset.type === 'video') {
            this.btnPopupFull = true;
          } else {
            this.btnPopupFull = false;
          }
        } else {
          elem.classList.remove('baseSlider__tab--active');
        }
      });
    },

    openFullPopup() {
      const activeTab = this.$el.querySelector('.baseSlider__tab--active');
      if (activeTab) {
        this.mediaArray = this.slider.btns.filter((elem => elem.id === this.$el.querySelector('.baseSlider__tab--active').dataset.name));
        const condition = activeTab.classList.contains('tabVideo');
        const videoData = this.slider.btns.find(el => el.id === activeTab.dataset.name);
        if (!condition) {
          this.$emit('fullscreen', {
            active: this.mainSlider.realIndex,
            cards: this.mediaArray[0].slider,
          });
        } else if (videoData) {
          this.$emit('openvideo', videoData.src);
        }
      }
    },
  },
};



// WEBPACK FOOTER //
// ./new-blocks/baseSlider/baseSlider.js